/* eslint-disable react/display-name */
import { CoreIcon } from '@woolworthslimited/core-components-react/icon';
import { ChangeEventHandler, InputHTMLAttributes, RefObject } from 'react';

import styles from './input.module.scss';

type InputProps = {
  rightButtonIcon?: React.ReactNode;
  inputType?: string;
  onIconClick?: () => void;
  maxChars?: number;
  clearButtonLabel?: string;
  rightButtonLabel?: string;
  inputRef?: RefObject<HTMLInputElement | null>;
  handleChange?: (value: string) => void;
} & InputHTMLAttributes<HTMLInputElement>;

export const Input: React.FC<InputProps> = ({
  rightButtonIcon,
  onIconClick,
  inputType,
  maxChars,
  clearButtonLabel,
  rightButtonLabel,
  handleChange,
  inputRef,
  ...inputProps
}) => {
  const clearSelection = () => {
    inputRef?.current.focus();
    handleChange('');
  };
  const onChange: ChangeEventHandler<HTMLInputElement> = (event) => {
    handleChange(event.target.value);
  };

  return (
    <label htmlFor={inputProps.name} className={styles.labelWrapper}>
      <input
        value={inputProps.value}
        ref={inputRef}
        className={styles.inputElement}
        type={inputType || 'text'}
        onChange={onChange}
        maxLength={maxChars ?? null}
        {...inputProps}
      />
      {inputProps.value && (
        <button
          className={styles.clearButton}
          onClick={clearSelection}
          aria-label={clearButtonLabel || 'clear'}
          type="button"
        >
          <CoreIcon name="icon-action-x-mark" ariaHidden />
        </button>
      )}
      {rightButtonIcon && (
        <button
          type="button"
          onClick={onIconClick}
          aria-label={rightButtonLabel || ''}
          className={styles.rightButtonIcon}
        >
          {rightButtonIcon}
        </button>
      )}
    </label>
  );
};
